import type { IconSvgObject } from './types';

const CircleSmallIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CircleSmallIcon;
